import components from "./components.js";
import oam from "./oam.js";
import rule from "./rule.js";
import transfer from "./transfer.js";

const dataObj = {
    'components':components,
    'oam':oam,
    'rule':rule,
    'transfer':transfer,
};
const flattenObject = (obj,res = {},pk = "")=>{
Object.entries(obj).forEach(([k,v])=>{
    if(typeof v === "object"){
      flattenObject(v,res,`${pk}.${k}`)
  }else{
    res[`${pk}.${k}`] = v
  }
 })
  return res
}
const allData = {}
Object.entries(dataObj).forEach(([ns, nsData]) => {
  flattenObject(nsData,allData,ns);
});

export default allData
